<template>
    <input ref="input" type="text" v-on:keyup="onKeyUp" v-model="inputValue" v-on:click="onSelect" inputmode="decimal" v-bind:id="id">
</template>

<script>
    export default {
        props: {
            value: null,
            id: null
        },
        data() {
            return {
                inputValue: this.value !== null ? keep2Decimals(this.value).toString() : null
            }
        },
        methods: {
            onSelect(event) {
                event.target.setSelectionRange(0, 100);
            },
            onKeyUp() {
                this.inputValue = removeNonNumericChars(this.inputValue);
                let parsedInputValue = Number.parseFloat(this.inputValue);
                if (isNaN(parsedInputValue)) {
                    parsedInputValue = null;
                }
                if (keep2Decimals(this.value) !== parsedInputValue) {
                    this.$emit('input', parsedInputValue);
                }
            }
        },
        watch: {
            value() {
                this.inputValue = this.value !== null ? keep2Decimals(this.value).toString() : null;
            },
        }
    }

    /* @return Number */
    function keep2Decimals(number) {
        return Math.round(number * 100) / 100;
    }

    /* @return String */
    function removeNonNumericChars(string) {
        if(string===null){
            return string;
        }
        return string
        // keep dash at the beginning only (can surely be improved !!!)
            .replace(/-/g, '_')
            .replace(/^_+/g, '-')
            .replace(/_*/g, '')
            // normalize comma to dot
            .replace(/,/g, '.')
            // remove all others chars
            .replace(/[^.0-9\-]/g, '');
    }


</script>